import { createSafeCaster } from './safeCaster';

const colorOptions = [
  'dark',
  'light',
  'brand',
  'light-faded',
  'medium-faded',
  'medium',
  'magenta',
  'red',
  'green',
  'light-green',
  'dark-green',
  'blue',
  'dark-red',
] as const satisfies Array<string>;
export type Color = (typeof colorOptions)[number];
export const castColor = createSafeCaster(colorOptions);

export const textColors: Record<Color, string> = {
  dark: 'text-st-gray-800',
  light: 'text-st-white',
  'light-faded': 'text-st-gray-100',
  'medium-faded': 'text-st-gray-300',
  medium: 'text-st-gray-500',
  brand: 'text-st-yellow',
  magenta: 'text-st-pink',
  red: 'text-st-red',
  green: 'text-st-green',
  'light-green': 'text-st-green-400',
  'dark-green': 'text-st-green-600',
  'dark-red': 'text-st-red-700',
  blue: 'text-st-blue',
};

export const headingColors: Record<Color, string> = {
  ...textColors,
  dark: 'text-st-black',
};

export const preHeadingColors: Record<Color, string> = {
  ...textColors,
  dark: 'text-st-black',
  brand: 'text-st-yellow-500',
  magenta: 'text-st-pink-500',
  red: 'text-st-red-500',
  green: 'text-st-green-500',
  blue: 'text-st-blue-500',
};

export const borderColors: Record<Color, string> = {
  dark: 'border-st-gray-800',
  light: 'border-st-white',
  'light-faded': 'border-st-gray-100',
  'medium-faded': 'border-st-gray-300',
  medium: 'border-st-gray-500',
  brand: 'border-st-yellow',
  magenta: 'border-st-pink',
  red: 'border-st-red',
  green: 'border-st-green',
  'light-green': 'border-st-green-400',
  'dark-green': 'border-st-green-600',
  blue: 'border-st-blue',
  'dark-red': 'text-st-red-700',
};
